export const apiName: string = 'pessoas-juridicas';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoa-juridica/shared/data.service.ts
 **/